import axios from "axios";
// axios创建实例对象
const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 600000,
});
// axios.baseURL: "https://dev.api.quliana.cn/api/",

export default instance;
